import * as React from 'react';

import { createIcon } from '../Icon';

export const GrabIcon = createIcon(
  <React.Fragment>
    <rect height="1" width="1" x="6" y="4" />
    <rect height="1" width="1" x="6" y="10" />
    <rect height="1" width="1" x="6" y="16" />
    <rect height="1" width="1" x="6" y="22" />
    <rect height="1" width="1" x="12" y="4" />
    <rect height="1" width="1" x="12" y="10" />
    <rect height="1" width="1" x="12" y="16" />
    <rect height="1" width="1" x="12" y="22" />
  </React.Fragment>,
  'GrabIcon'
);
